// state holds all current key-value pairs mirrored in the URL
const state = {};

// compare will compare two values to determine if they are the same
const compare = (a, b) => (JSON.stringify(a) === JSON.stringify(b));

// getParamString will return ?key=value string if there are params, or an empty string otherwise
const getParamString = (params) => (params.toString() ? `?${params.toString()}` : '');

// getURL will return the full path plus query string based on current params
const getURL = (params) => (window.location.pathname + getParamString(params));

// updateHistory will replace the browser URL with the new query string (no page reload)
const updateHistory = (params) => (window.history.replaceState({}, '', getURL(params)));

// updateURL will rebuild URLSearchParams from state and update browser history
const updateURL = () => {
    const params = new URLSearchParams(state);
    updateHistory(params);
};

// clear will remove all keys from state
const clear = () => {
    for (const key in state) {
        if (Object.prototype.hasOwnProperty.call(state, key)) delete state[key];
    }
};

// get will retrieve a value from state, or fall back to default, or null
const get = (key, defaultValue) => (state[key] || defaultValue || null);

// set will store a value in state and update the URL accordingly
const set = (key, ...values) => {
    if (compare(state[key], values)) return;
    state[key] = values;
    updateURL();
};

// remove will delete a key from state and update the URL
const remove = (key) => {
    delete state[key];
    updateURL();
};

// reset will call clear and then update the URL
const reset = () => {
    clear();
    updateURL();
};

// populate will iterate through parameters and populate state with the current values
const populate = (params) => {
    for (const [key, value] of params.entries()) {
        state[key] = value.split(',');
    }
};

// sync will call clear and then populate state using the current URL parameters
const sync = () => {
    const params = new URLSearchParams(window.location.search);
    clear();
    populate(params);
};

// Run sync once on initial load
sync();

// export default will provide the API with get, set, remove, reset, and sync functions
export default {
    get,
    set,
    remove,
    reset,
    sync,
};
